export function getSubvencionsRoute(pathname = window.location.pathname) {
    const params = pathname.split('/').filter(part => part !== '');
    const detailSlug = params[1] || null;
    const detailYear = params[2] || null;

    return {
        detailSlug,
        detailYear,
        isDetailView: Boolean(detailSlug),
    };
}
